import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import logo from "@/assets/sortiven-logo.png";

const links = [
  { to: "/", label: "Inicio", key: "inicio", end: true },
  { to: "/juego/triple", label: "TripleFalcón Venezuela", key: "triple" },
  { to: "/juego/animalitos", label: "ZooloFalcón Venezuela", key: "animalitos" },
  { to: "/verificar", label: "Verificar", key: "verificar" },
  { to: "/bitacora", label: "Bitácora", key: "bitacora" },
  { to: "/documentacion", label: "Documentación", key: "documentacion" },
];

export const PublicLayout = () => {
  const loc = useLocation();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-10">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img src={logo} alt="SORTIVEN — Sorteador Integral" className="h-10 w-auto" />
          </Link>
          <nav className="hidden items-center gap-1 lg:flex">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`nav-${l.key}`}
                className={({ isActive }) =>
                  `rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
                    isActive ? "bg-secondary text-foreground" : "text-muted-foreground hover:text-foreground"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <Link to={user ? "/consola" : "/login"} data-testid="nav-consola">
            <Button variant="outline" size="sm" className="gap-1.5">
              <LogIn className="h-4 w-4" /> {user ? "Consola" : "Acceder"}
            </Button>
          </Link>
        </div>
        <div className="flex gap-1 overflow-x-auto border-t border-border px-4 py-2 lg:hidden">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`nav-mobile-${l.key}`}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-1 text-xs font-medium ${
                  isActive ? "bg-secondary" : "text-muted-foreground"
                }`}>
              {l.label}
            </NavLink>
          ))}
        </div>
      </header>
      <main key={loc.pathname}>
        <Outlet />
      </main>
      <footer className="mt-16 border-t border-border bg-card">
        <div className="mx-auto max-w-6xl px-4 py-8 text-sm text-muted-foreground sm:px-6 lg:px-10">
          <img src={logo} alt="SORTIVEN" className="h-9 w-auto" />
          <p className="mt-3 font-display font-semibold text-foreground">SORTIVEN V1.4</p>
          <p className="mt-1 max-w-2xl">
            Sistema de sorteo con aleatoriedad verificable (provably-fair) y bitácora inmutable.
          </p>
          <div className="mt-3 flex flex-wrap gap-4 text-xs">
            <Link to="/documentacion" className="hover:text-foreground">Documentación del algoritmo</Link>
            <Link to="/verificar" className="hover:text-foreground">Verificar un sorteo</Link>
            <Link to="/bitacora" className="hover:text-foreground">Bitácora pública</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
